import {MenuItem} from '@material-ui/core';
import {getNonEmptyStringErrors} from 'Core/models/EmptyString';
import * as O from 'fp-ts/lib/Option';
import {
  changeAccountNumber,
  changeControlNumber,
  changePayorName,
  changePlacePolicyOnDirectBill,
} from 'Agent/Policies/ducks/policyServiceRequest';
import {PremiumMode} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';
import {PayrollAllotmentChangeRequest} from 'Agent/Policies/models/ServiceRequest/PayrollAllotmentChangeRequest';
import React from 'react';
import {useDispatch} from 'react-redux';
import {compose} from 'redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import ValidatableTextField from 'Shared/components/ValidatableTextField';

type ChangePayrollAllotmentProps = {
  payrollAllotmentBillingChanges: PayrollAllotmentChangeRequest;
};

const PayrollAllotmentBillingChanges = (props: ChangePayrollAllotmentProps) => {
  const {payrollAllotmentBillingChanges} = props;
  const dispatch = useDispatch();
  const selectedPremiumMode = O.isSome(payrollAllotmentBillingChanges.billingSchedule)
    ? payrollAllotmentBillingChanges.billingSchedule.value
    : '';

  return (
    <div>
      <ValidatableTextField
        label="Account Number"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(payrollAllotmentBillingChanges.accountNumber)}
        onChange={compose(dispatch, changeAccountNumber)}
        value={payrollAllotmentBillingChanges.accountNumber.value}
      />
      <ValidatableTextField
        label="Control Number"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(payrollAllotmentBillingChanges.controlNumber)}
        onChange={compose(dispatch, changeControlNumber)}
        value={payrollAllotmentBillingChanges.controlNumber.value}
      />
      <ValidatableTextField
        label="Payor Name"
        className="service-request-form__field"
        errors={getNonEmptyStringErrors(payrollAllotmentBillingChanges.payorName)}
        onChange={compose(dispatch, changePayorName)}
        value={payrollAllotmentBillingChanges.payorName.value}
      />
      <OutlinedSelect
        label="Premium Mode"
        className="service-request-form__field"
        value={selectedPremiumMode}
        onChange={e => dispatch(changePlacePolicyOnDirectBill(parseInt(e.target.value, 10)))}
      >
        <MenuItem value={PremiumMode.Annual}>Annual</MenuItem>
        <MenuItem value={PremiumMode.PreauthorizedCheckPlan}>Pre-Authorized Check Plan</MenuItem>
        <MenuItem value={PremiumMode.Quarterly}>Quarterly</MenuItem>
        <MenuItem value={PremiumMode.Semiannual}>Semi-Annual</MenuItem>
      </OutlinedSelect>
    </div>
  );
};

export default PayrollAllotmentBillingChanges;
